import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import useTranslation from "../../../../../../packages/locales/translations/util/useTranslation";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { MediaPlacementsModal } from "../MediaPlacementsModal/MediaPlacementsModal";
import styles from "./media-placement-section-search.module.css";
import { useState } from "react";
import { MediasAndArticleCountResponse } from "@coworker/app/src/components/RoomSettings/types/media";

interface MediaPlacementSectionSearchProps {
  mediasAndArticleCount: MediasAndArticleCountResponse[];
  itemCardContent: React.ReactElement | null;
}
export const MediaPlacementSectionSearch = ({
  mediasAndArticleCount,
  itemCardContent,
}: MediaPlacementSectionSearchProps) => {
  const { t } = useTranslation();

  const [showMediasPlacementModal, setShowMediasPlacementModal] =
    useState(false);
  const handleShowMediasPlacementModal = () => {
    setShowMediasPlacementModal(true);
  };

  const totalMediaCount = new Set(
    mediasAndArticleCount?.map((item) => item.mediaId)
  ).size;

  return (
    <div className={styles["media-placement-section-search"]}>
      <div className={styles["media-placement-section-search-inner-container"]}>
        <FixaText textStyle="Body.S">Media placements</FixaText>
        <FixaText textStyle="Heading.XS">
          Article is placed in {totalMediaCount} media
        </FixaText>
      </div>
      <div className={styles["show-modal-button-container"]}>
        <FixaButton
          text={t("allMediaPlacementsString")}
          htmlType="button"
          fluid
          size="medium"
          onClick={handleShowMediasPlacementModal}
        />
        {itemCardContent && (
          <MediaPlacementsModal
            itemCardContent={itemCardContent}
            showModal={showMediasPlacementModal}
            mediasAndArticleCount={mediasAndArticleCount}
            onClose={() => setShowMediasPlacementModal(false)}
          />
        )}
      </div>
    </div>
  );
};
